module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c003#toc1"
    }
  }, [_vm._v("Forget Vacation")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c004#toc2"
    }
  }, [_vm._v("Belgian Mussels")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c005#toc3"
    }
  }, [_vm._v("Rejected Project")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c006#toc4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In A Children’s Playground")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c007#toc5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Shirt with Style")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c008#toc6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bread for the Ducks")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c009#toc7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Straw-Colored Carpet")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c010#toc8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turkish Lessons")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c011#toc9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bulletin Board")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c012#toc10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Waste Basket")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c013#toc11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Legal Counsel")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c014#toc12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Underage Girl")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c015#toc13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Raid")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c016#toc14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Working Relationships")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c017#toc15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Case of Beer")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c018#toc16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Urgent Warning")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c019#toc17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Windmill")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c020#toc18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family Honor")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c021#toc19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Windmill Again")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26d5053e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c002.vue
// module id = 60
// module chunks = 0